// COMPONENTS
import LoggedIn from "../../layouts/loggedIn.layout";
import UsersPage from "./page.users.page";

const Layout = () => {
  return (
    <LoggedIn>
      <UsersPage />
    </LoggedIn>
  );
};

export default Layout;
